/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { snackbar } from './core/controller/snackbar_controller'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered(registration) {
      setInterval(() => {
        registration.update()
        console.log('Service worker has been registered.');
      }, 10000)
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    async updated() {
      console.log('New content is available; please refresh.')
      const confirm = await snackbar.confirm({ message: "Há uma nova versão, deseja atualizar a página?", color: "green" })

      if (confirm) {
        window.location.reload()
      }
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
